export var partnerBankDetailsMapper = function (data) {
    var resBankDetails = data.data;
    var partnerBankDetails = {
        bankDetails: [],
    };
    resBankDetails.forEach(function (item) {
        partnerBankDetails.bankDetails.push({
            accountNo: item.account_code,
            accountType: item.account_type_name,
            bankAddress: item.address1,
            bankCity: item.city,
            bankName: item.bank_name,
            bankPin: item.pincode,
            bankState: item.state,
            ifscCode: item.ifsc_code,
            micr: item.micr_code,
            nameAsPerBank: item.name_as_per_bank,
        });
    });
    return partnerBankDetails;
};
